import { ReactComponent as IconAddressBook } from '../../icons/address-book.svg';
import { ReactComponent as IconAgreement } from '../../icons/agreement.svg';
import { ReactComponent as IconAirplane } from '../../icons/airplane.svg';
import { ReactComponent as IconApproval } from '../../icons/approval.svg';
import { ReactComponent as IconAverage } from '../../icons/average.svg';
import { ReactComponent as IconBoxFalling } from '../../icons/box-falling.svg';
import { ReactComponent as IconBox } from '../../icons/box.svg';
import { ReactComponent as IconBreakable } from '../../icons/breakable.svg';
import { ReactComponent as IconBriefcase } from '../../icons/briefcase.svg';
import { ReactComponent as IconBusiness } from '../../icons/business.svg';
import { ReactComponent as IconCalender } from '../../icons/calender.svg';
import { ReactComponent as IconCar } from '../../icons/car.svg';
import { ReactComponent as IconCheap } from '../../icons/cheap.svg';
import { ReactComponent as IconCheckmark } from '../../icons/checkmark.svg';
import { ReactComponent as IconChecksheet } from '../../icons/checksheet.svg';
import { ReactComponent as IconClipboard } from '../../icons/clipboard.svg';
import { ReactComponent as IconClock } from '../../icons/clock.svg';
import { ReactComponent as IconContactDetails } from '../../icons/contact-details.svg';
import { ReactComponent as IconContacts } from '../../icons/contacts.svg';
import { ReactComponent as IconDelete } from '../../icons/delete.svg';
import { ReactComponent as IconDepartment } from '../../icons/department.svg';
import { ReactComponent as IconDocument } from '../../icons/documents.svg';
import { ReactComponent as IconDossier } from '../../icons/dossier.svg';
import { ReactComponent as IconEmojiWink } from '../../icons/emoji-wink.svg';
import { ReactComponent as IconGift } from '../../icons/gift.svg';
import { ReactComponent as IconGolfBag } from '../../icons/golf-bag.svg';
import { ReactComponent as IconHouseSimple } from '../../icons/house-simple.svg';
import { ReactComponent as IconHouse } from '../../icons/house.svg';
import { ReactComponent as IconInTransit } from '../../icons/in-transit.svg';
import { ReactComponent as IconInfo } from '../../icons/info-icon.svg';
import { ReactComponent as IconInvestmentPortfolio } from '../../icons/investment-portfolio.svg';
import { ReactComponent as IconLast24Hours } from '../../icons/last-24-hours.svg';
import { ReactComponent as IconLocation } from '../../icons/location.svg';
import { ReactComponent as IconLock } from '../../icons/lock.svg';
import { ReactComponent as IconMailOpen } from '../../icons/mail-open.svg';
import { ReactComponent as IconMailbox } from '../../icons/mailbox.svg';
import { ReactComponent as IconMarketing } from '../../icons/marketing.svg';
import { ReactComponent as IconNewProduct } from '../../icons/new-product.svg';
import { ReactComponent as IconNotification } from '../../icons/notification.svg';
import { ReactComponent as IconOrganization } from '../../icons/organization.svg';
import { ReactComponent as IconPackage } from '../../icons/package.svg';
import { ReactComponent as IconPackaging } from '../../icons/packaging.svg';
import { ReactComponent as IconPadlock } from '../../icons/padlock.svg';
import { ReactComponent as IconParcel } from '../../icons/parcel.svg';
import { ReactComponent as IconPeople } from '../../icons/people.svg';
import { ReactComponent as IconPicture } from '../../icons/picture.svg';
import { ReactComponent as IconPrint } from '../../icons/print.svg';
import { ReactComponent as IconProduct } from '../../icons/product.svg';
import { ReactComponent as IconProject } from '../../icons/project.svg';
import { ReactComponent as IconReadMessage } from '../../icons/read-message.svg';
import { ReactComponent as IconSettings } from '../../icons/settings.svg';
import { ReactComponent as IconSheep } from '../../icons/sheep.svg';
import { ReactComponent as IconShipment } from '../../icons/shipment.svg';
import { ReactComponent as IconShopLocation } from '../../icons/shop-location.svg';
import { ReactComponent as IconShop } from '../../icons/shop.svg';
import { ReactComponent as IconShoppingBag } from '../../icons/shopping-bag.svg';
import { ReactComponent as IconSummaryList } from '../../icons/summary-list.svg';
import { ReactComponent as IconTags } from '../../icons/tags.svg';
import { ReactComponent as IconTechnicalSupport } from '../../icons/technical-support.svg';
import { ReactComponent as IconUploadCloud } from '../../icons/upload-cloud.svg';
import { ReactComponent as IconUserChat } from '../../icons/user-chat.svg';
import { ReactComponent as IconVendingMachine } from '../../icons/vending-machine.svg';

export const iconDropdownMapper = {
	addressBook: IconAddressBook,
	agreement: IconAgreement,
	airplane: IconAirplane,
	approval: IconApproval,
	average: IconAverage,
	breakable: IconBreakable,
	briefcase: IconBriefcase,
	business: IconBusiness,
	calender: IconCalender,
	cheap: IconCheap,
	checksheet: IconChecksheet,
	checkmark: IconCheckmark,
	clock: IconClock,
	contactDetails: IconContactDetails,
	delete: IconDelete,
	contacts: IconContacts,
	department: IconDepartment,
	document: IconDocument,
	dossier: IconDossier,
	gift: IconGift,
	info: IconInfo,
	inTransit: IconInTransit,
	investmentPortfolio: IconInvestmentPortfolio,
	last24hours: IconLast24Hours,
	lock: IconLock,
	mailbox: IconMailbox,
	marketing: IconMarketing,
	newProduct: IconNewProduct,
	notification: IconNotification,
	organization: IconOrganization,
	package: IconPackage,
	packaging: IconPackaging,
	padlock: IconPadlock,
	people: IconPeople,
	picture: IconPicture,
	print: IconPrint,
	product: IconProduct,
	project: IconProject,
	readMessage: IconReadMessage,
	settings: IconSettings,
	shop: IconShop,
	shopLocation: IconShopLocation,
	shoppingBag: IconShoppingBag,
	summaryList: IconSummaryList,
	technicalSupport: IconTechnicalSupport,
	uploadCloud: IconUploadCloud,
	vendingMachine: IconVendingMachine,
	falling: IconBoxFalling,
	box: IconBox,
	car: IconCar,
	clipboard: IconClipboard,
	'emoji-wink': IconEmojiWink,
	'golf-bag': IconGolfBag,
	'house-simple': IconHouseSimple,
	house: IconHouse,
	location: IconLocation,
	'mail-open': IconMailOpen,
	parcel: IconParcel,
	sheep: IconSheep,
	shipment: IconShipment,
	tags: IconTags,
	'user-chat': IconUserChat,
	user: IconUserChat,
};
